import * as React from 'react';
import { AddressInfo, AddressInfoError } from '../geo/address.types';
import { LOGO_HERE, M3PLUS, servicePackages } from './business.constants';
import AddressComponent from '../geo/address.component';
import TextField from 'material-ui/TextField';
import { AuthState } from '../auth/auth.types';
import { SignupState, BusinessRegisterRequest } from '../admin/signup.types';
import ImageUploadComponent from '../util/ImageUploadComponent';
import { ServicePackage, BusinessState } from './business.types';

type Props = {
  readonly businessState: BusinessState
  readonly authState: AuthState
  readonly signupState: SignupState
  readonly validateBusinessPhoneNumber: (phone: string) => Promise<Response>
  readonly businessRegisterRequestHandler: (request: BusinessRegisterRequest) => void
  readonly businessRegisterRequest: BusinessRegisterRequest
  readonly addressInfo: AddressInfo
  readonly addressInfoHandler: (addressInfo: AddressInfo) => void
  readonly addressInfoError: AddressInfoError
  readonly onBusinessLogoImageFileHandler: (fileFormatError: string, fileSizeError: string, newImageFile: File) => void
  readonly fileSizeError: string
};

type States = {
  readonly name: string
  readonly nameError: string
  readonly registerErrorMessage: string
  readonly businessLogoUrl: string
  readonly servicePackage: ServicePackage;
};

class BusinessRegisterComponent extends React.Component<Props, States> {
  
  constructor(props: Props) {
    super(props);

    this.state = {
      name: '',
      nameError: '',
      servicePackage: M3PLUS,
      registerErrorMessage: '',
      businessLogoUrl: LOGO_HERE
    };
  }

  render() {
    const { businessLogoUrl, name, nameError, servicePackage } = this.state;
    const {
      validateBusinessPhoneNumber, addressInfo, addressInfoError, addressInfoHandler, onBusinessLogoImageFileHandler,
      fileSizeError
    } = this.props;

    return (
      <div className="container">
        <div className="row ma2">
          <div className="col-12">
            <h3 className="f3">General Information (required)</h3>
          </div>
        </div>
        <div className="row ma2">
          <div className="col-12">
            <div 
              className={
                (nameError ? 'has-danger ' : '') +
                'input-group mb-2 mr-sm-2 mb-sm-0'
              }
            >
              <div className="input-group-addon border-0 mr-2">
                <i className="material-icons f3">
                  business
                </i>
              </div>
              <TextField
                fullWidth={true}
                hintText="Business Name"
                value={name}
                onChange={this.onNameChage}
              />
            </div>
          </div>
        </div>
        <AddressComponent
          addressInfo={addressInfo}
          addressInfoError={addressInfoError}
          addressInfoChangeHandler={addressInfoHandler}
          validatePhoneNumber={true}
          validator={validateBusinessPhoneNumber}
          isBusinessRegistration={true}
          businessState={this.props.businessState}
        />
        <hr />
        <div className="row ma2">
          <div className="col-12">
            <h3 className="f3">Business Logo (optional)</h3>
          </div>
        </div>
        <div className="row ma2">
          <div className="col-4">
            <div className="input-group mb-2 mr-sm-2 mb-sm-0">
              <ImageUploadComponent
                defaultImageUrl={businessLogoUrl}
                onImageFileChangeHandler={onBusinessLogoImageFileHandler}
              />
            </div>
          </div>
          <div className="col-3 red">
            {fileSizeError}
          </div>
        </div>
        <hr />
        <div className="row ma2">
          <div className="col-12">
            <h3 className="f3">Service Package</h3>
          </div>
        </div>
        <div className="row ma2">
          <div className="col-12">
            <select
              className="form-control"
              value={servicePackage}
              onChange={this.onServicePackageChange}
            >
              {
                servicePackages.map((sp, index) => {
                  return <option key={index} value={sp.value}>{sp.name}</option>;
                })
              }
            </select>
          </div>
        </div>
        <hr />
        <div className="container">
          <div className="row">
            <div className="col-12">
              {this.state.registerErrorMessage}
            </div>
          </div>
        </div>
      </div>
    );
  }

  private onNameChage = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState(
      {name: newValue},
      () => this.props.businessRegisterRequestHandler({
        ...this.props.businessRegisterRequest,
        name: newValue
      })
    )
  
  private onServicePackageChange = (event: React.FormEvent<HTMLSelectElement>): void => {
    const sp = event.currentTarget.value as ServicePackage;

    this.setState(
      {servicePackage: sp},
      () => this.props.businessRegisterRequestHandler({
        ...this.props.businessRegisterRequest,
        servicePackage: sp
      })
    );
  }
}

export default BusinessRegisterComponent;



// WEBPACK FOOTER //
// ./src/business/register.component.tsx